// src/utils/uploadFile.js
// PDF / Word documents ko Cloudinary par upload karne ke liye.
//
// ⚠️ CLOUD_NAME aur UPLOAD_PRESET wahi daalein jo aapki
//    src/utils/uploadImage.js mein pehle se likhe hue hain.

const CLOUD_NAME = "drnodzoty";
const UPLOAD_PRESET = "school_website";

export const MAX_FILE_MB = 10; // Cloudinary free plan ki limit
const ALLOWED_EXT = ["pdf", "doc", "docx"];

export function validateDocument(file) {
  if (!file) return "Please select a file";
  const ext = file.name.split(".").pop().toLowerCase();
  if (!ALLOWED_EXT.includes(ext)) return "Only PDF, DOC or DOCX files are allowed";
  if (file.size > MAX_FILE_MB * 1024 * 1024)
    return "File is too large (max " + MAX_FILE_MB + " MB)";
  return "";
}

export async function uploadDocumentToCloudinary(file) {
  const error = validateDocument(file);
  if (error) throw new Error(error);

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);
  formData.append("folder", "school-documents");

  const res = await fetch(
    "https://api.cloudinary.com/v1_1/" + CLOUD_NAME + "/raw/upload",
    { method: "POST", body: formData }
  );
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error?.message || "Upload failed");

  return { url: data.secure_url, publicId: data.public_id };
}

// Link ko "download" mode mein badalta hai (browser mein khulne ke bajaye save ho)
export function forceDownloadUrl(url) {
  if (!url || !url.includes("/upload/")) return url;
  return url.replace("/upload/", "/upload/fl_attachment/");
}